import { defineStore } from 'pinia';
import gateService from '@/services/gate.service';

import createHumps from 'lodash-humps/lib/createHumps';
import { snakeCase } from 'lodash-es';
const snakes = createHumps(snakeCase)



type RegistrationProps = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string,
    requestType: string,
    // status: string,
    state: string,
    metadata: {
        yourProfile: string
        companyIndustry: string;
        termsAndConditions: boolean;
        positions: string
    }
};

export const useSignUpStore = defineStore({
    id: 'SignUpStore',
    state: () => ({
        one: <RegistrationProps>{
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            requestType: "self",
            // status: "requested",
            state: "requested",
            metadata: {
                yourProfile: "",
                companyIndustry: "",
                termsAndConditions: false,
                positions: ""
            }
        },
    }),
    getters: {
        getOne: (state) => state.one,
        // getSignUpMessage: (state) => state.signUpMessage,
        // getErrorMessage: (state) => state.errorMessage,
        // getInProgress: (state) => state.inProgress,
    },
    actions: {
        // setInProgress(flag: boolean) {
        //   this.inProgress = flag 
        // },
        // signUpSuccess(user: any) {
        //   this.inProgress = false;
        //   this.errorMessage = "";
        //   this.signUpMessage = "You have registered successfully"
        //  // this.one = user;
        // },
        // prepareWithMessage({ errorMessage, signUpMessage }: { errorMessage: string, signUpMessage: string }) {
        //   this.inProgress = false;
        //   this.errorMessage = errorMessage;
        //   this.signUpMessage = signUpMessage;
        //   this.setOne()
        // },
        setOne() {
            const initialObj: RegistrationProps = {
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                requestType: "self",
                // status: "requested",
                state: "requested",
                metadata: {
                    yourProfile: "",
                    companyIndustry: "",
                    termsAndConditions: false,
                    positions: ""
                }
            };
            this.one = initialObj
        },

        async save({ appId }: { appId: string }) {
            try {
                const dataToStore = await gateService.doCreateAccount({
                    one: snakes({
                        // ...this.one,
                        appId: appId,
                        firstName: this.one.firstName,
                        lastName: this.one.lastName,
                        email: this.one.email,
                        phoneNumber: this.one.phoneNumber,
                        requestType: this.one.requestType,
                        // status: this.one.status,
                        state: this.one.state,
                        metadata: {
                            yourProfile: this.one.metadata.yourProfile,
                            companyIndustry: this.one.metadata.companyIndustry,
                            termsAndConditions: this.one.metadata.termsAndConditions,
                            positions: this.one.metadata.positions,
                        }
                    }),
                });

                if (dataToStore && dataToStore.status) {
                    // this.signUpSuccess(dataToStore)
                    return ({ save: true, response: dataToStore });
                }
                return dataToStore

            } catch (err: any) {
                console.log(err)
                throw err

            }

        }
    }
});